module.exports = __webpack_public_path__ + "img/slide-6.54be5a63.jpg";